import React, { useState, useEffect } from 'react'
import debug from 'debug'

import { ProjectConfig } from '@vt/comps'
import RoutesConfig from '@config/routes'
import { vtProject, initProject } from './config/init'
import Operate, { customOperateSlugs } from './components/Operate'

import '@ow/comps/dist/style.css'
import '@ow/comps/dist/font.css'
import '@ow/comps/dist/scrollbar.css'

const customCompsMap = {
  OperateComponent: Operate,
  customOperateSlugs,
}
const App = function () {
  const [appInited, setAppInited] = useState(false)
  useEffect(() => {
    initProject().then(() => {
      setAppInited(true)
    })
  }, [])
  window.ddd = debug
  debug('测试 debug')
  return (
    appInited && (
      <ProjectConfig
        customCompsMap={customCompsMap}
        vtProject={vtProject}
        // createCustomStore={createCustomStore}
      >
        <RoutesConfig />
      </ProjectConfig>
    )
  )
}
export default App
